import React from "react";
import "./FormInput.scss";

const FormCheckbox = (props) => {
	let id = 'id-'+Math.random()
	return (
		<div className={`checkbox ${props.error ? "has-error" : ""} ${props.className ? props.className: ""}`}>
			<input className="form-check-input" name={props.name} type="checkbox" value={props.value} id={id} onChange={props.updateState} defaultChecked={props.defaultChecked}/>
			<label className="form-check-label" htmlFor={id}>{props.labelHtml ? <div dangerouslySetInnerHTML={{ __html: (props.label) }}></div> : props.label}{props.isRequired ? <sup>*</sup> : ""}</label>
			<span className="error">{props.error}</span>
		</div>
	);
};

export default FormCheckbox;
